import BaseComponent from '@js/BaseComponent'
import Toast from '@js/Toast'

/**
 * Wrapper to add download Toast to undecorated download links.
 *
 * @extends BaseComponent
 */
class UndecoratedDownloadLink extends BaseComponent {
    constructor(element) {
        super(element)

        if (sir.isEditor) return

        const hasDownload = typeof element.download !== 'undefined'
        const filename = element.download || element.href.split('/').pop()

        if (hasDownload) {
            element.addEventListener('click', () => {
                setTimeout(() => {
                    new Toast(`Downloading <strong>${filename}</strong>`)
                }, 150)
            })
        }
    }
}

UndecoratedDownloadLink.create('a[download].undecorated-download')
